import { useState } from 'react'
import { ConfirmDialog, useDialogState } from '@/components/common/ConfirmDialog'
import { useAuth } from './useAuth'

/**
 * Shared sign-out confirmation for every sign-out control.
 *
 * Signing out drops the session and returns to the sign-in screen, so a trigger
 * must never fire it straight away. Call `requestSignOut` from the button or
 * menu item, and render `dialog` once alongside it.
 */
export function useSignOutConfirmation() {
  const { signOut } = useAuth()
  const confirm = useDialogState<true>()
  const [busy, setBusy] = useState(false)

  const requestSignOut = () => confirm.show(true)

  const handleConfirm = async () => {
    setBusy(true)
    try {
      await signOut()
    } finally {
      setBusy(false)
      confirm.close()
    }
  }

  const dialog = (
    <ConfirmDialog
      open={confirm.open}
      title="Confirmation"
      message="Any unsaved changes will be lost."
      confirmLabel="Sign out"
      confirmColor="primary"
      loading={busy}
      onConfirm={() => void handleConfirm()}
      onClose={confirm.close}
    />
  )

  return { requestSignOut, dialog }
}
